import script from "./DoubleDataCell.vue?vue&type=script&setup=true&lang=js"
export * from "./DoubleDataCell.vue?vue&type=script&setup=true&lang=js"

import "./DoubleDataCell.vue?vue&type=style&index=0&id=208771c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208771c0"]])

export default __exports__